export default "__VITE_ASSET__DDMny38H__"